import React, { useState } from "react";
import ApplyProgramInfo from "../components/ApplyProgram/ApplyProgramInfo";

import Aside from "../modules/SideNav/Aside";

function AllProgramsInfoLayout() {
  const rtl = false;

  const [toggled, setToggled] = useState(false);

  const handleToggleSidebar = (value) => {
    setToggled(value);
  };

  return (
    <>
      {/* <Aside
        rtl={rtl}
        toggled={toggled}
        handleToggleSidebar={handleToggleSidebar}
      /> */}
      <ApplyProgramInfo handleToggleSidebar={handleToggleSidebar} />
    </>
  );
}

export default AllProgramsInfoLayout;
